import React from "react";

import { Card, Heading1, Paragraph } from "../../atoms";
import styled from "styled-components";
import { device } from "../../../../utils";
import { Container } from "react-grid-system";
import { SouthOfFranceTreatmentTable } from "./components/south-of-france-treatment-table";
import { SouthOfFranceTableTab } from "./components/south-of-france-service-tab";
import { useHandleTreatments } from "./hooks/use-handle-south-of-france-treatment";
import { useTreatmentData } from "./hooks/use-treatment-data";
import { CheckoutButtonContainer } from "./components/checkout-button";
import { useHeaderHeight } from "../../../../providers/header-height-provider";

const HeaderContainer = styled.section<{
  topOffset: number;
}>`
  top: ${({ topOffset }) => `-${topOffset + 18}px`};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${({ theme, topOffset }) =>
    `${topOffset + 22}px ${theme.spacing.size18} 0`};
  background-color: ${({ theme }) => theme.colours.darkRed};
  z-index: 99;

  @media ${device.tablet} {
    padding-top: ${({ topOffset }) => `${topOffset + 18}px`};
    top: ${({ topOffset }) => `-${topOffset + 22}px`};
  }
`;

const MainContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.size20};
  @media ${device.laptop} {
    max-width: 750px !important;
    padding: 0 !important;
  }
`;

const HeadingStyled = styled(Heading1)`
  text-align: center;
  color: ${({ theme }) => theme.colours.white};
  margin-bottom: 0;
`;

const ParagraphStyled = styled(Paragraph)`
  color: ${({ theme }) => theme.colours.white};
  text-align: center;
`;

const BottomOffset = styled.div<{
  height: number;
}>`
  height: ${({ height }) => `${height}px`};
`;

const TherapistPortfolioContainer = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.size18};
`;

const PortfolioCard = styled(Card)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface SouthOfFranceLandingPageProps {
  isWebView?: boolean;
}

export const SouthOfFranceLandingPage = ({
  isWebView,
}: SouthOfFranceLandingPageProps): JSX.Element => {
  const topOffset = useHeaderHeight();
  const { treatmentsData } = useTreatmentData();

  const {
    addedTreatments,
    handleAddTreatment,
    handleRemoveTreatment,
    redirectToFormWithDetails,
  } = useHandleTreatments({
    treatments: treatmentsData.flatMap((grouped) => grouped.treatments) ?? [],
  });

  return (
    <>
      <HeaderContainer topOffset={topOffset}>
        <HeadingStyled>Select your treatment</HeadingStyled>
        <ParagraphStyled>
          Browse our menu below and select your preferred treatment or
          treatments.
        </ParagraphStyled>
        <BottomOffset height={24} />
      </HeaderContainer>

      <MainContainer>
        <BottomOffset height={12} />
        <TherapistPortfolioContainer>
          <PortfolioCard>
            <SouthOfFranceTableTab />
            <SouthOfFranceTreatmentTable
              treatmentsData={treatmentsData}
              onAddTreatment={handleAddTreatment}
              onRemoveTreatment={handleRemoveTreatment}
              addedTreatment={addedTreatments}
            />
          </PortfolioCard>
        </TherapistPortfolioContainer>
      </MainContainer>
      <BottomOffset height={24} />
      <CheckoutButtonContainer
        addedTreatments={addedTreatments}
        onCheckout={redirectToFormWithDetails}
        isWebView={isWebView}
      />
    </>
  );
};
